<template>
  <div class="chat">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <left-sidebar></left-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper" style="min-height: 657px;
      left: 0;
      padding-top: 60px;">
        <!-- Chat Main Row -->
        <div class="chat-main-row">
          <!-- Chat Main Wrapper -->
          <div class="chat-main-wrapper">
            <!-- Chats View -->
            <div class="col-lg-9 message-view task-view">
              <div class="chat-window">
                <div class="chat-contents">
                  <div class="chat-content-wrap">
                    <div class="chat-wrap-inner">
                      <div class="chat-box">
                        <div class="chats">
                          <div class="chat chat-left">
                            <div class="chat-avatar">
                              <Skeleton :circle="true" :count="1" :height="'20px'" :width="'20px'" />
                            </div>
                            <div class="chat-body">
                              <div class="chat-bubble">
                                <div class="chat-content">
                                  <span class="task-chat-user">
                                    <Skeleton :count="1" :width="'200px'" />
                                  </span>
                                  <span class="chat-time">
                                    <Skeleton :count="1" :width="'50px'" />
                                  </span>
                                  <div class="call-details">
                                    <div class="call-info">
                                      <div class="call-user-details">
                                        <span class="call-description">
                                          <Skeleton :count="1" />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="chat chat-right">
                            <div class="chat-avatar">
                              <Skeleton :circle="true" :count="1" :height="'20px'" :width="'20px'" />
                            </div>
                            <div class="chat-body">
                              <div class="chat-bubble">
                                <div class="chat-content">
                                  <span class="task-chat-user">
                                    <Skeleton :count="1" :width="'200px'" />
                                  </span>
                                  <span class="chat-time">
                                    <Skeleton :count="1" :width="'50px'" />
                                  </span>
                                  <div class="call-details">
                                    <div class="call-info">
                                      <div class="call-user-details">
                                        <span class="call-description">
                                          <Skeleton :count="1" />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-footer">
                  <div class="message-bar">
                    <div class="message-inner">
                      <a class="link attach-icon" href="#" data-toggle="modal" data-target="#drag_files">
                        <img src="@/assets/attachment.png" alt />
                      </a>
                      <div class="message-area">
                        <div class="input-group">
                          <textarea class="form-control" placeholder="Type message..."></textarea>
                          <span class="input-group-append">
                            <button class="btn btn-custom" type="button">
                              <i class="fa fa-send"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Chats View -->

            <!-- Chat Right Sidebar -->
            <right-sidebar></right-sidebar>
            <!-- /Chat Right Sidebar -->
          </div>
          <!-- /Chat Main Wrapper -->
        </div>
      </div>
    </div>

    <!-- edit client -->
    <a style="display:none;" href="#" class="btn add-btn" data-toggle="modal" data-target="#showConnectToAgentOwner"
      id="btnShowConnectToAgentOwner"></a>
    <div id="showConnectToAgentOwner" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Please wait in a moment</h5>
            <button style="display:none;" id="btnCloseConnectToAgentOwner" type="button" class="close hidden"
              data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <center>We are connecting to your agent...</center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import LayoutHeader from "@/components/layouts/Header.vue";
import LeftSidebar from "./LeftSidebar.vue";
import RightSidebar from "./RightSidebar.vue";
export default {
  components: {
    LayoutHeader,
    LeftSidebar,
    RightSidebar,
    Skeleton
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
    //  isactive : true
  },
  watch: {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },

  computed: {
    ...mapGetters([
      "hotChatListArr",
      "activeRoomId",
      "textMessageArr",
      "agentSession",
      "activeProvider",
      "NEW_UNREAD_MESSAGE_ROOM_Data"
    ])
    // newUUID: function() {
    //   const newID = uuid.v4();
    //   return newID;
    // }
  },
  async created() {
    var that = await this;
    await setTimeout(async function () {
      var licenseId = await that.$route.query.license_id;
      var agentId = await that.$route.query.agent_id;
      await that.connectToAgentOwner(licenseId, agentId);
    }, 1000);
  },

  methods: {
    async popup() {
      await document.getElementById("btnShowConnectToAgentOwner").click(); // Click on the checkbox
    },
    async connectToAgentOwner(licenseId, agentId) {
      if (typeof agentId == "undefined") {
        agentId = "";
      }
      let redirect = ""
      if (typeof (this.$route.query.redirect) != 'undefined' && this.$route.query.redirect != '') {
        redirect = this.$route.query.redirect
      }
      // console.log("redirect",redirect)
      // console.log("redireparamsct",this.$route.query.redirect)
      // return
      var dataArr = {
        license_id: licenseId,
        agent_id: agentId
      };
      await this.$store
        .dispatch("agent/connectToAgentOwner", dataArr)
        .then(response => {
          this.$fire({
            title: "Preparing An Agent Session",
            text: "please wait, redirecting...",
            type: "success",
            timer: 3000
          }).then(async r => {
            // await this.$router.push("/omni");
            if (redirect == "") {
              window.location.href = this.baseUrl + "/omni"
            } else {
              window.location.href = this.baseUrl + redirect
            }
          });
        })
        .catch(() => {
          this.$router.push("/agent/list");
        });
    }
  },
  name: "connecttoagentowner"
};
</script>


// WEBPACK FOOTER //
// src/views/agentconnect/index.vue